import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { useMemo, useState } from "react";

import { Stack } from "@mui/system";
import { axiosInstance } from "src/api/axios";
import CustomTextField from "../../../components/forms/theme-elements/CustomTextField";
const cities = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttarakhand",
  "Uttar Pradesh",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and",
  "The Government of NCT of Delhi",
  "Jammu & Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];
const occupations = [
  "Bank Employee",
  "Student",
  "Financial Advisor",
  "Sales Manager",
  "DSA",
  "Influencer",
  "Professional",
  "Others",
];
const ProfileRegister = ({ title, subtitle, subtext }) => {
  const [occupation, setoccupation] = useState("");
  const [dob, setdob] = useState("");
  const [gender, setgender] = useState("");
  const [city, setcity] = useState("");
  const [pinCode, setpincode] = useState("");
  const [error, setError] = useState("");
  const theme = useTheme();

  useMemo(() => {
    axiosInstance.get("/users").then((response) => {
      if (response.status === 200) {
        let { data } = response;
        if (data.city) {
          window.location.href = "/dashboard";
        }
      }
    });
  }, []);

  const submit = async () => {
    setError("");
    try {
      let payload = {
        occupation,
        dob,
        gender,
        pinCode,
        city,
      };
      let required = Object.entries(payload).filter((i) => !i[1]);
      if (required.length) {
        setError(`${required[0][0]} Is Required`);
        return;
      }
      let response = await axiosInstance.patch("/users", {
        occupation,
        dob,
        gender,
        pinCode,
        city,
      });
      if (!response) {
        return;
      }

      let { data, status } = response;
      if (status < 202) {
        localStorage.setItem("store", JSON.stringify(data));
        window.location.href = "/";
      } else {
        setError(response.response.data.message);
      }
    } catch (e) {
      console.log(e.message);
    }
  };
  return (
    <>
      {title ? (
        <Typography fontWeight="700" variant="h2" mb={1}>
          {title}
        </Typography>
      ) : null}

      {subtext}

      <Box>
        <Stack
          mb={3}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              submit();
            }
          }}
        >
          <FormControl sx={{ flex: 1 }}>
            <InputLabel id="city">Occupation</InputLabel>
            <Select
              required
              labelId="occupation"
              id="occupation"
              label="Occupation"
              onChange={(e) => setoccupation(e.target.value)}
            >
              {occupations.map((job) => (
                <MenuItem value={job}>{job}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <Grid item xs={12}>
            <Stack
              direction={"row"}
              spacing={2}
              my={2}
              justifyContent={"space-between"}
            >
              <FormControl
                sx={{
                  minWidth: "50%",
                }}
              >
                <label id="dob">Date of Birth</label>
                <TextField
                  variant={"outlined"}
                  type={"date"}
                  onChange={(e) => setdob(e.target.value)}
                />
              </FormControl>

              <FormControl
                sx={{
                  minWidth: "45%",
                }}
              >
                <label id="gender">Gender</label>
                <Select
                  required
                  labelId="gender"
                  id="gender"
                  label="Gender"
                  onChange={(e) => setgender(e.target.value)}
                >
                  <MenuItem value="male">Male</MenuItem>
                  <MenuItem value="female">Female</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                </Select>
              </FormControl>
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <Stack
              direction="row"
              spacing={1}
              my={1}
              alignItems="center"
              justifyContent={"space-between"}
            >
              <FormControl
                sx={{
                  width: "60%",
                }}
              >
                <InputLabel id="city">State</InputLabel>
                <Select
                  required
                  labelId="state"
                  id="state"
                  label="State"
                  onChange={(e) => setcity(e.target.value)}
                >
                  {cities.map((city) => (
                    <MenuItem value={city}>{city}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              <CustomTextField
                id="pin"
                variant="outlined"
                label="pin code"
                type={"number"}
                sx={{
                  width: "55%",
                  marginLeft: "1rem",
                }}
                setState={setpincode}
              />
            </Stack>
          </Grid>
        </Stack>
        <Button
          sx={{
            bgcolor: theme.palette.earnpati.main,
            fontWeight: "bold",
            width: "100%",
          }}
          variant="contained"
          size="large"
          fullWidth
          onClick={submit}
        >
          Create Account
        </Button>
        <Typography
          variant="subtitle1"
          fontWeight={600}
          component="label"
          htmlFor="confirmpassword"
          mb="5px"
          mt="25px"
        >
          {!error ? null : <p style={{ color: "red" }}>{error}</p>}
        </Typography>
      </Box>
      {subtitle}
    </>
  );
};

export default ProfileRegister;
